export const UserRolePermission = {};
